// import React from "react";
// import { Container, Row, Col, Form, Button } from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";
// // import "./ContactUsPage.css"; // for custom styles
// import "./../../assets/css/ContactUsPage.css"
// const ContactUsPage = () => {
//   return (
//     <div className="contact-page">
//       {/* Top Background Image with Heading */}
//       <div className="contact-hero">
//         <div className="overlay text-white">
//           <h5>LET'S KEEP IN TOUCH</h5>
//           <h2 className="fw-bold">CONTACT US</h2>
//         </div>
//       </div>

//       {/* Contact Info Section */}
//       <Container className="py-5">
//         <Row className="gy-4">
//           {/* Left Column */}
//           <Col md={4}>
//             <h5 className="fw-bold">CONTACT AGENCY</h5>
//             <p className="text-muted">
//               There are many variations of passages of Lorem Ipsum available, but the majority
//               have suffered alteration in some form...
//             </p>
//           </Col>

//           {/* Middle Column */}
//           <Col md={4}>
//             <h5 className="fw-bold">OUR CONTACTS</h5>
//             <p>
//               <strong>Address:</strong> 120 E 87th Street, New York
//             </p>
//             <p>
//               <strong>Phone:</strong>{" "}
//               <span className="text-warning fw-bold">1-800-987-9898</span>
//             </p>
//             <p>
//               <strong>Email:</strong> info@domain-name.com
//             </p>
//           </Col>

//           {/* Right Column - Contact Form */}
//           <Col md={4}>
//             <h5 className="fw-bold">ANY QUESTIONS?</h5>
//             <Form>
//               <Form.Group className="mb-3">
//                 <Form.Control type="text" placeholder="Your Name" />
//               </Form.Group>
//               <Form.Group className="mb-3">
//                 <Form.Control type="email" placeholder="Email" />
//               </Form.Group>
//               <Form.Group className="mb-3">
//                 <Form.Control as="textarea" rows={3} placeholder="Message" />
//               </Form.Group>
//               <Button variant="warning" className="text-white px-4">
//                 SEND MESSAGE
//               </Button>
//             </Form>
//           </Col>
//         </Row>
//       </Container>
//     </div>
//   );
// };

// export default ContactUsPage;


// import React from "react";
// import { Container, Row, Col, Form, Button } from "react-bootstrap";
// import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaGlobe, FaClock } from "react-icons/fa";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "./../../assets/css/ContactUsPage.css"
// const styles = {
//   section: {
//     padding: "60px 15px",
//     background: "#f5f9f8",
//     fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
//     color: "#333",
//   },
//   card: {
//     backgroundColor: "#fff",
//     borderRadius: "16px",
//     padding: "30px 25px",
//     boxShadow: "0 8px 20px rgba(0, 0, 0, 0.07)",
//     marginBottom: "30px",
//   },
//   subheader: {
//     color: "#8f0909ff",
//     fontWeight: "600",
//     fontSize: "1.6rem",
//     marginBottom: "15px",
//     borderBottom: "2px solid #8f0909ff",
//     paddingBottom: "6px",
//     display: "inline-block",
//   },
//   icon: {
//     color: "#f06b43ff",
//     marginRight: "10px",
//     verticalAlign: "middle",
//     fontSize: "1.3rem",
//   },
//   link: {
//     color: "#8f0909ff",
//     fontWeight: "600",
//     textDecoration: "none",
//     cursor: "pointer",
//   },
//   servicesList: {
//     listStyleType: "disc",
//     paddingLeft: "1.5rem",
//     lineHeight: 1.75,
//     color: "#444",
//     fontSize: "1.05rem",
//   },
//   reputationText: {
//     fontStyle: "italic",
//     color: "#555",
//     fontSize: "1.05rem",
//     lineHeight: 1.6,
//   },
// };

// const ContactUsPage = ({ webSettings }) => {
//   const office = webSettings?.ourOffice?.[0];

//   return (
//     <div className="contact-page">
//       <div className="contact-hero">
//         <div className="overlay text-white">
//           <h5>LET'S KEEP IN TOUCH</h5>
//           <h2 className="fw-bold">CONTACT US</h2>
//         </div>
//       </div>

//       <Container style={styles.section}>
//         <Row className="gy-4">
//           {/* Left Column - Address & Contact Info */}
//           <Col md={5}>
//             <div style={styles.card}>
//               <h4 style={styles.subheader}>Address</h4>
//               <p>
//                 <FaMapMarkerAlt style={styles.icon} />
//                 {office?.address}
//               </p>

//               <h4 style={styles.subheader}>Phone</h4>
//               <p>
//                 <FaPhone style={styles.icon} />
//                 {office?.phone}
//               </p>

//               <h4 style={styles.subheader}>Email</h4>
//               <p>
//                 <FaEnvelope style={styles.icon} />
//                 {office?.email}
//               </p>

//               <h4 style={styles.subheader}>Website</h4>
//               <p>
//                 <FaGlobe style={styles.icon} />
//                 <a
//                   href={`https://${office?.websiteurl}`}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   style={styles.link}
//                 >
//                   {office?.websiteurl}
//                 </a>
//               </p>
//             </div>
//           </Col>

//           {/* Middle Column - Business Hours & Services */}
//           <Col md={4}>
//             <div style={styles.card}>
//               <h4 style={styles.subheader}>Business Hours (Office)</h4>
//               <p>
//                 <FaClock style={styles.icon} />
//                 Monday - Saturday: 9:00 AM - 7:00 PM <br />
//                 Sunday: Closed
//               </p>
// {/* 
//               <h4 style={{ ...styles.subheader, marginTop: "40px" }}>
//                 Services Offered
//               </h4> */}

//               {/* SAME DESIGN – data from JSON */}
//               <div
//                 dangerouslySetInnerHTML={{
//                   __html: webSettings?.servicesAndTransportation,
//                 }}
//               />

//               {/* <h4 style={{ ...styles.subheader, marginTop: "40px" }}>
//                 Reputation
//               </h4> */}

//               {/* SAME DESIGN – data from JSON */}
//               <div
//                 dangerouslySetInnerHTML={{
//                   __html: webSettings?.aboutRadheshyamTravels,
//                 }}
//               />
//             </div>
//           </Col>

//           {/* Right Column - Contact Form */}
//           <Col md={3}>
//             <div
//               style={{
//                 background: "#fff",
//                 padding: "30px",
//                 borderRadius: "16px",
//                 boxShadow: "0 8px 20px rgba(0,0,0,0.07)",
//               }}
//             >
//               <h5 className="fw-bold mb-4" style={{ color: "#8f0909ff" }}>
//                 ANY QUESTIONS?
//               </h5>
//               <Form>
//                 <Form.Group className="mb-3">
//                   <Form.Control type="text" placeholder="Your Name" />
//                 </Form.Group>
//                 <Form.Group className="mb-3">
//                   <Form.Control type="email" placeholder="Email" />
//                 </Form.Group>
//                 <Form.Group className="mb-3">
//                   <Form.Control as="textarea" rows={3} placeholder="Message" />
//                 </Form.Group>
//                 <Button variant="success" className="w-100 text-white px-4">
//                   SEND MESSAGE
//                 </Button>
//               </Form>
//             </div>
//           </Col>
//         </Row>
//       </Container>
//     </div>
//   );
// };

// export default ContactUsPage;



import { useState } from "react";
import { Container, Row, Col, Form, Button, Badge } from "react-bootstrap";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaGlobe, FaClock, FaPaperPlane, FaHeadset } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import BASE_URL from "../../component/commanfile";



const ContactUsPage = ({ webSettings }) => {
  const offices = webSettings?.ourOffice || [];
  
const [formData, setFormData] = useState({
  name: "",
  mobile_number: "",
  customerNotes: "",
  email:"",
  type:"custom"
});

const [loading, setLoading] = useState(false);
const [success, setSuccess] = useState("");
const [error, setError] = useState("");

  const theme = {
    primary: "#8f0909",
    dark: "#082e5e",
    light: "#f8f9fa"
  };

  const styles = {
    hero: {
      background: `linear-gradient(rgba(58, 57, 121, 0.8), rgba(10, 29, 55, 0.9)), 
                   url('https://images.unsplash.com/photo-1423666639041-f56000c27a9a?auto=format&fit=crop&w=1600&q=80')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed',
      padding: "100px 0 140px", // Bottom padding thoda badhaya hai
      textAlign: "center",
      position: "relative",
      width: "100%"
      // clipPath hata diya hai taaki cards cut na ho
    },
    infoCard: {
      border: "none",
      borderRadius: "24px",
      padding: "30px",
      height: "100%",
      backgroundColor: "#fff",
      boxShadow: "0 15px 35px rgba(0,0,0,0.08)", // Shadow thodi visible ki hai
      transition: "transform 0.3s ease",
      position: "relative",
      zIndex: 5 // Cards ko upar rakhne ke liye
    },
    iconBox: {
      width: "55px",
      height: "55px",
      borderRadius: "15px",
      backgroundColor: "#fff1f1",
      color: theme.primary,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "1.4rem",
      marginBottom: "20px"
    },
    input: {
      borderRadius: "12px",
      padding: "14px 20px",
      border: "1px solid #eee",
      backgroundColor: "#fcfcfc",
      fontSize: "0.95rem"
    }
  };
const handleChange = (e) => {
  setFormData({
    ...formData,
    [e.target.name]: e.target.value
  });
};
const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setError("");
  setSuccess("");

  try {
    const res = await axios.post(
      `${BASE_URL}api/tourinquery`,
      {
        name: formData.name,
        mobileNumber: formData.mobile_number,
        customerNotes: formData.customerNotes,
        email:formData.email,
        type:"custom"
      },
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    );

    if (res.data?.status === true || res.status === 200) {
      setSuccess("Inquiry sent successfully! Our team will contact you soon.");
      setFormData({ name: "", phone: "", message: "" });

    } else {
      setError(res.data?.message || "Something went wrong");
    }
  } catch (err) {
    console.error("Tour inquiry error", err);
    setError("Server error. Please try again later.");
  } finally {
    setLoading(false);
  }
};

  return (
    <div style={{ backgroundColor: "#f4f7f9", fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      
      {/* 1. HERO SECTION */}
      <div style={styles.hero} className="text-white">
        <Container>
          <Badge bg="danger" className="mb-3 px-3 py-2 text-uppercase fw-bold shadow-sm" style={{ letterSpacing: "2px" }}>
            <FaHeadset className="me-2" /> 24/7 Support Available
          </Badge>
          <h1 style={{ fontSize: "clamp(2.5rem, 8vw, 4.5rem)", fontWeight: "900", marginBottom: "20px" }}>Contact Us</h1>
          <p className="mx-auto" style={{ maxWidth: "700px", fontSize: "1.1rem", opacity: 0.9 }}>
            Planning your dream vacation or need business travel assistance? Our experts are just a message away.
          </p>
        </Container>
      </div>

      {/* 2. MAIN CONTENT AREA */}
      <Container style={{ marginTop: "-70px", position: "relative", zIndex: 10, paddingBottom: "100px" }}>
        <Row className="gy-4">
          
          {/* OFFICE LOCATIONS & MORE */}
          <Col lg={8}>
            <Row className="gy-4">
              {/* Dynamic Offices Mapping */}
              {offices.map((office, idx) => (
                <Col md={6} key={idx} >
                  <div style={styles.infoCard} className="hover-lift shadow-sm">
                    <div style={styles.iconBox}><FaMapMarkerAlt /></div>
                    <Badge bg="danger" className="mb-2">{office.type}</Badge>
                    <h5 className="fw-bold">{office.name}</h5>
                    <p className="text-muted small mb-3" style={{ minHeight: "40px" }}>{office.address}</p>
                    
                    <div className="pt-3 border-top">
                      <div className="mb-2 small d-flex align-items-center">
                        <FaPhoneAlt className="text-danger me-2" /> 
                        <span>{office.phone}</span>
                        
                      </div>
                      {office.contacts?.length > 0 && (
          <div className="mb-3 border-start ps-3 py-1">
            {office.contacts.map((contact, index) => (
              <div key={index} className="d-flex justify-content-between mb-1">
                <small className="text-muted">{contact.name}</small>
                <small className="fw-medium text-dark">Mo: {contact.phone}</small>
              </div>
            ))}
          </div>
        )}
                      <div className="small d-flex align-items-center">
                        <FaEnvelope className="text-danger me-2" /> 
                        <span className="text-truncate">{office.email}</span>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}

              {/* MODERN INFO BANNER */}
              <Col md={12}>
                <div style={{ ...styles.infoCard, background: theme.dark, color: "#fff", padding: "40px" }}>
                  <Row className="align-items-center">
                    <Col md={7}>
                      <h4 className="fw-bold mb-3 d-flex align-items-center text-white">
                        <FaClock className="me-3 text-danger" /> Operation Hours
                      </h4>
                      <div className="opacity-75">
                        <div className="d-flex justify-content-between mb-2 border-bottom border-secondary pb-1">
                          <span>Monday - Saturday</span>
                          <span>11:00 AM - 07:30 PM</span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span>Sunday</span>
                          <span className="text-danger fw-bold text-uppercase" style={{ fontSize: "0.8rem" }}>Emergency Only</span>
                        </div>
                      </div>
                    </Col>
                    <Col md={5} className="text-md-end mt-4 mt-md-0">
                      <div className="p-3 rounded-4" style={{ background: "rgba(255,255,255,0.05)" }}>
                        <FaGlobe className="mb-2 text-danger fs-3" />
                        <h6 className="mb-1 text-white">Official Website</h6>
                        <a href={`https://${offices[0]?.websiteurl}`} target="_blank" rel="noreferrer" className="text-white-50 small text-decoration-none">
                          {offices[0]?.websiteurl}
                        </a>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Col>

          {/* 3. CONTACT FORM */}
          <Col lg={4}>
            <div style={{ ...styles.infoCard, borderTop: `8px solid ${theme.primary}`, position: "sticky", top: "20px" }}>
              <div className="mb-4">
                <h4 className="fw-bold mb-1">Quick Inquiry</h4>
                <p className="text-muted small">Fill out the form and we'll reply soon.</p>
              </div>
      <Form onSubmit={handleSubmit}>
  <Form.Group className="mb-3">
    <Form.Label className="small fw-bold text-muted">Full Name</Form.Label>
    <Form.Control
      style={styles.input}
      type="text"
      name="name"
      value={formData.name}
      onChange={handleChange}
            placeholder="Enter your full name" // 🔹 placeholder
      required
    />
  </Form.Group>

  <Form.Group className="mb-3">
    <Form.Label className="small fw-bold text-muted">Phone Number</Form.Label>
    <Form.Control
      style={styles.input}
      type="tel"
      name="mobile_number"
      value={formData.mobile_number}
      onChange={handleChange}
            placeholder="Enter your mobile number" // 🔹 placeholder
      required
    />
  </Form.Group>
    <Form.Group className="mb-3">
    <Form.Label className="small fw-bold text-muted">Email Address</Form.Label>
    <Form.Control
      style={styles.input}
      type="email"
      name="email"
      value={formData.email}
      onChange={handleChange}
            placeholder="Enter your email address" // 🔹 placeholder
      // required
    />
  </Form.Group>

  <Form.Group className="mb-4">
    <Form.Label className="small fw-bold text-muted">Message</Form.Label>
    <Form.Control
      as="textarea"
      rows={4}
      style={styles.input}
      name="customerNotes"
      value={formData.customerNotes}
      onChange={handleChange}
            placeholder="Enter your message" // 🔹 placeholder
      required
    />
  </Form.Group>

  {success && <p className="text-success small">{success}</p>}
  {error && <p className="text-danger small">{error}</p>}

  <Button
    type="submit"
    className="w-100 py-3 border-0"
    style={{ borderRadius: "15px", fontWeight: "700", backgroundColor: "#082e5e" }}
    disabled={loading}
  >
    {loading ? "Sending..." : "SEND MESSAGE"}
  </Button>
</Form>

            </div>
          </Col>
        </Row>

        {/* 4. MAP SECTION */}
     <div className="mt-5 rounded-4 overflow-hidden shadow-sm border">
  <iframe
    title="office-location"
    src="https://www.google.com/maps?q=Radheshyam+Travels+Pvt+Ltd+Ahmedabad&output=embed"
    width="100%"
    height="400"
    style={{ border: 0 }}
    loading="lazy"
  ></iframe>
</div>
      </Container>
    </div>
  );
};

export default ContactUsPage;